import axios from 'axios';


export default {
  // Collection
  createWine (data) {
    return axios.post(`/wines`, data)
      .then(response => response.data);
  },
  getWines () {
    return axios.get(`/wines`)
      .then(response => response.data);
  },

  // Item
  getWine (id) {
    return axios.get(`/wines/${id}`)
      .then(response => response.data);
  },
  updateWine (data) {
    return axios.put(`/wines/${data.wine_id}`, data)
      .then(response => response.data);
  },
  deleteWine (id) {
    return axios.delete(`/wines/${id}`)
      .then();
  },

  // Subs
  updateLabel (id, formData) {
    return axios.post(`/wines/${id}/label`, formData)
      .then(response => response.data);
  }
};
